































import Vue from 'vue'
import { LanguageRow, UiLanguageItem, UiLanguageList } from '@/types'

interface ComponentData {
  languageRows: Array<LanguageRow>
  languageValidationRules: Array<Function>
}

export default Vue.extend({
  name: 'WorkEditorDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },

    dialogSaveButtonLoading: {
      type: Boolean
    }

  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('errors.required').toString()

    return {
      languageRows: [],
      languageValidationRules: [
        required
      ],
    }
  },

  computed: {
    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onCancelButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']

      if (form.validate()) {
        this.$emit('save', this.languageRows)
      }
    },

    resetForm (): void {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }

      this.languageRows = []
      this.languageRows = this.uiLanguageList.map((item: UiLanguageItem) => {
        return {
          code: item.syzId,
          description: '',
          language: item.code
        }
      })
    }
  },

  mounted (): void {
    this.languageRows = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        code: item.syzId,
        description: '',
        language: item.code
      }
    })

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField[0]) {
        focusedField[0].focus()
      }
    }, 0)
  }

})
